import { Box } from '@wix/design-system';
import {
  CardElevation,
  DeprecatedProductsCardsList,
  HatPosition,
  MarketingItem,
  ProductCardContainer,
  ProductCardDivider,
  ShadowBehavior,
} from '@wix/package-picker-components';
import React, { ReactNode } from 'react';
import { ProductCardData } from 'types';
import s from './CardsContainer.scss';

interface CardsContainerProps {
  productsCardsData: ProductCardData[];
}

export function CardsContainer({ productsCardsData }: CardsContainerProps) {
  const maxFeaturesAmount: number = productsCardsData
    .map((productCard) => productCard.data.features.length)
    .sort()
    .reverse()[0];

  function getShadowBehavior(currentProductIndex: number): ShadowBehavior {
    return productsCardsData[currentProductIndex].data.isRecommended ||
      productsCardsData[currentProductIndex + 1]?.data.isRecommended
      ? ShadowBehavior.Shadow
      : ShadowBehavior.Border;
  }

  return (
    <Box className={s.cardsContainer} width='100%'>
      <DeprecatedProductsCardsList marketingItemsAmount={maxFeaturesAmount}>
        {productsCardsData.map((product, index) => {
          const { data, components } = product;
          const { features, isCurrentPlan, isRecommended, id } = data;
          const { cta, hat, price, title } = components;
          const childComponents: ReactNode[] = [];
          const paddedFeaturesAmount = maxFeaturesAmount - features.length;
          const paddedFeatures = Array(paddedFeaturesAmount).fill({ text: '' });
          const cardFeatures: MarketingItem[] = [
            ...features,
            ...paddedFeatures,
          ];
          const shadowBehavior = getShadowBehavior(index);
          const elevated =
            isRecommended || isCurrentPlan
              ? CardElevation.Large
              : CardElevation.None;
          childComponents.push(
            <ProductCardContainer
              className={s.cardContainer}
              key={`${id}-cardContainer`}
              highlighted={isRecommended}
              elevated={elevated}
              hat={hat}
              hatPosition={HatPosition.OutsideCard}
              header={title}
              pricing={price}
              cta={cta}
              marketingItems={cardFeatures}
            />,
          );
          if (index < productsCardsData.length - 1) {
            childComponents.push(
              <ProductCardDivider
                key={`${id}-divider`}
                shadowBehavior={shadowBehavior}
              />,
            );
          }

          return childComponents;
        })}
      </DeprecatedProductsCardsList>
    </Box>
  );
}
